import { useQuery } from '@tanstack/react-query';
import { client } from '../../lib/amplify-client';

/**
 * Voucher-feature TanStack Query hooks.
 *
 * `useGetVoucherBalance` reads the authenticated user's voucher balance.
 * Only fires when `enabled` is true (i.e. the user is authenticated).
 */

export interface VoucherBalance {
  balance: number;
  points: number;
}

async function fetchVoucherBalance(): Promise<VoucherBalance> {
  const result = await client.queries.getVoucherBalance({
    authMode: 'userPool',
  });
  if (result.errors && result.errors.length > 0) {
    throw new Error(
      `getVoucherBalance failed: ${result.errors.map((e) => e.message).join('; ')}`,
    );
  }
  return (result.data as VoucherBalance | null) ?? { balance: 0, points: 0 };
}

export function useGetVoucherBalance(enabled: boolean) {
  return useQuery({
    queryKey: ['vouchers', 'balance'] as const,
    queryFn: fetchVoucherBalance,
    enabled,
    staleTime: 30_000,
  });
}
